export default {
    parts: [],
    baseStyle: (props) => ({
    })
}
